import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  httpClient,
} from "settings/apolloClient.jsx";

export const AUTHORIZED_OPERATOR_QUERY = gql`
  query {
    getCurrentAutomationOperator {
      id
      name
    }
  }
`;

const AuthorizedOperatorContext = createContext({
  operator: null,
  loading: true,
  refetch: () => {},
});

export const useAuthorizedOperator = () => useContext(AuthorizedOperatorContext);

export const AuthorizedOperatorProvider = ({ children }) => {
  const { data, loading, refetch } = useQuery(AUTHORIZED_OPERATOR_QUERY, {
    fetchPolicy: "network-only",
    client: httpClient,
  });

  const [operator, setOperator] = useState(null);

  useEffect(() => {
    if (data && data.getCurrentAutomationOperator) {
      setOperator(data.getCurrentAutomationOperator);
    } else {
      setOperator(null);
    }
  }, [data]);

  return (
    <AuthorizedOperatorContext.Provider value={{ operator, loading, refetch }}>
      {children}
    </AuthorizedOperatorContext.Provider>
  );
};
